export const HASH_FORGET = 'forget';
export const HASH_SIGNIN = 'entrance';
export const HASH_SIGNUP = 'registration';
export const HASH_MODAL = 'question';
export const HASH_WARNING = 'warning';
export const HASH_NOKIDS = 'nokidswarning';
export const HASH_AUTH_SERVICES = 'auth-services';
export const ESIA_500_ERROR = [
    {
        content: 'К СОЖАЛЕНИЮ ПОРТАЛ ГОСУСЛУГ НЕ ОТВЕЧАЕТ',
        strong: true,
    },
    'Пожалуйста, попробуйте авторизоваться позже, либо воспользуйтесь формой регистрации Навигатора.',
];




// WEBPACK FOOTER //
// ./src/pages/default/popup/forms/const.js